import * as S from './style';
const MembershipGuide = () => (
	<>
		<S.Container>
			<S.Title>회원구분 및 자격</S.Title>
			<S.Table>
				<S.TableHeadCell>회원구분</S.TableHeadCell>
				<S.TableHeadCell>자격</S.TableHeadCell>

				<S.PositionCell>정회원</S.PositionCell>
				<S.TableCell className="min-height-ul">
					<ul>
						<li>박사학위를 소지한 또는 이에 동등한 자격을 갖춘 자</li>
						<li>대학 전임강사</li>
						<li>연구소 선임연구원 이상</li>
						<li>또는 이에 준하는 전문 기관 및 기업의 경력 자격이 있는 자로서 연회비를 납부한 자</li>
					</ul>
				</S.TableCell>
				<S.PositionCell className="min-height">학생회원</S.PositionCell>
				<S.TableCell>대학(교), 대학원의 재학생 및 연구소의 석사급 이하 연구원</S.TableCell>
				<S.PositionCell className="min-height">특별회원</S.PositionCell>
				<S.TableCell>본회의 목적과 사업을 위해 학회에 기여도가 높은 자</S.TableCell>
				<S.PositionCell className="min-height">명예회원</S.PositionCell>
				<S.TableCell>본회의 명예 및 위상을 드높이는 자</S.TableCell>
			</S.Table>
		</S.Container>
		<S.Container>
			<S.Title>회원 혜택</S.Title>
			<S.DescriptionBox>
				<S.SubTitle>학회 등록비 할인</S.SubTitle>
				<S.Description>매년 개최하는 춘계,추계학술대회의 등록비 할인이 제공됩니다.</S.Description>
			</S.DescriptionBox>
			<S.DescriptionBox>
				<S.SubTitle>노화학회 주요 소식 이메일 알림</S.SubTitle>
				<S.Description>공지사항, 학술대회 안내, 신규 학술지 등 우리 학회의 주요 소식이 메일로 제공됩니다.</S.Description>
			</S.DescriptionBox>
		</S.Container>
		<S.Container>
			<S.Title>회원 가입 방법</S.Title>
			<S.Description>한국노화학회 홈페이지에서 온라인 가입</S.Description>
		</S.Container>
	</>
);
export default MembershipGuide;
